export default __webpack_public_path__ + "static/media/hht1_ep11_timeline_q01_b.3fd7e37a.png";